// extracted by mini-css-extract-plugin
export default {"basicInfoWrapper":"basicInfo_basicInfoWrapper__4NkpG","table-purple":"basicInfo_table-purple__cZ3ar"};